<template>
	<div>
		<div :class="modalIsOpen ? 'side-over--active' : ''">
			<div
				class="fixed h-screen w-screen top-0 left-0 bg-black opacity-20 z-30"
				v-if="modalIsOpen"
				@click="modalIsOpen = false"
			></div>
			<CreateGoalModal
				:show="modalIsOpen"
				v-model:skills="skills"
				v-model:data="goalPayloadData"
				v-model:error="error"
				v-model:tab-active="tabActive"
				@submit="() => {}"
				@close="closeModal"
				@updated="updated"
			/>
		</div>
		<div class="w-full">
			<div class="mb-10" v-if="alertShow">
				<div
					class="bg-yellow-50 border-l-4 border-yellow-600 p-4 rounded-md"
				>
					<div class="relative">
						<div>
							<img
								src="@/assets/images/logo/logo.svg"
								alt="luca-logo"
								height="24"
								width="35"
							/>
						</div>
						<div class="mt-3 text-neutral-600 text-sm">
							Bạn hãy thêm mục tiêu từ Thư viện nội bộ vào Ngân
							hàng mục tiêu.
						</div>
						<div
							class="top-1 right-2 absolute cursor-pointer"
							@click="alertShow = false"
						>
							<svg
								width="12"
								height="12"
								viewBox="0 0 12 12"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M0.292893 0.292893C0.683417 -0.0976311 1.31658 -0.0976311 1.70711 0.292893L6 4.58579L10.2929 0.292893C10.6834 -0.0976311 11.3166 -0.0976311 11.7071 0.292893C12.0976 0.683417 12.0976 1.31658 11.7071 1.70711L7.41421 6L11.7071 10.2929C12.0976 10.6834 12.0976 11.3166 11.7071 11.7071C11.3166 12.0976 10.6834 12.0976 0.292893 11.7071L6 7.41421L1.70711 11.7071C1.31658 12.0976 0.683417 12.0976 0.292893 11.7071C-0.0976311 11.3166 -0.0976311 10.6834 0.292893 10.2929L4.58579 6L0.292893 1.70711C-0.0976311 1.31658 -0.0976311 0.683417 0.292893 0.292893Z"
									fill="#E5A42B"
								/>
							</svg>
						</div>
					</div>
				</div>
			</div>
			<div>
				<div>
					<div class="__report-lesson pb-10">
						<div
							class="__breadcrumbs text-sm text-neutral-500 font-semibold flex-nowrap flex items-center justify-between"
						>
							<div class="flex items-center">
								<router-link
									:to="{
										name: 'create_goal_by_lib',
									}"
								>
									Thư viện nội bộ
								</router-link>
								<div class="__breadcrumbs__decorate">
									<DaIcon
										name="das--chevron-down"
										class="transform -rotate-90 h-3 w-3 mx-2"
									/>
								</div>
								<div>{{ goal.name }}</div>
							</div>
						</div>
						<div
							class="mt-6 __report-lesson__header flex w-full flex-col items-stretch gap-4 md:flex-row md:flex-nowrap md:items-center md:justify-between"
						>
							<div
								class="__record__title text-neutral-500 font-semibold flex min-w-0 items-start gap-3 text-4xl md-down:text-2xl"
							>
								<router-link
									:to="{ name: 'create_goal_by_lib' }"
									class="mt-1 flex-shrink-0 text-neutral-400 hover:text-neutral-600"
								>
									<DaIcon
										name="das--chevron-down"
										class="transform rotate-90 h-5 w-5"
									/>
								</router-link>
								<svg
									width="28"
									height="28"
									viewBox="0 0 28 28"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
									class="mb-1 flex-shrink-0"
								>
									<path
										d="M25.4998 5.98259H11.021C10.7609 5.98259 10.5219 5.8514 10.3931 5.63913L9.104 3.51831C8.65802 2.78525 7.83103 2.33337 6.93503 2.33337H2.5C1.11897 2.33337 0 3.38904 0 4.69193V22.1415C0 23.4444 1.11897 24.5 2.5 24.5H25.5C26.881 24.5 28 23.4444 28 22.1415V8.34109C28 7.03906 26.881 5.98253 25.5 5.98253L25.4998 5.98259ZM4.09697 16.1387H6.65903C7.15613 16.1387 7.55903 16.5188 7.55903 16.9878C7.55903 17.4567 7.15613 17.8368 6.65903 17.8368H4.09697C3.59987 17.8368 3.19697 17.4567 3.19697 16.9878C3.19697 16.5188 3.59987 16.1387 4.09697 16.1387ZM10.437 21.1483H4.09697C3.59987 21.1483 3.19697 20.7682 3.19697 20.2992C3.19697 19.8303 3.59987 19.4501 4.09697 19.4501H10.4381C10.9352 19.4501 11.3381 19.8303 11.3381 20.2992C11.3379 20.768 10.935 21.1483 10.437 21.1483Z"
										fill="#94A3B8"
									/>
								</svg>
								<span class="min-w-0 break-words">{{
									goal.name
								}}</span>
							</div>
							<button
								data-tour-id="bank-add-selected"
								class="delete-button flex items-center self-end whitespace-nowrap md:self-auto"
								:class="{
									'disable-button':
										goalsSelected.length == 0 &&
										!isAddGoalTour,
								}"
								@click="addMultiGoal"
							>
								Thêm mục tiêu đã chọn
							</button>
						</div>
						<div class="mt-2">
							<div v-if="!isDataLoading">
								<div v-if="folders.length">
									<div
										v-for="folder in folders"
										:key="folder.id"
									>
										<GoalFolderItem
											:is-edit="false"
											:data="folder"
											:skills="skills"
											:selected-goal="selected"
											@action-clicked="doGoal"
											:isInCreateGoal="true"
										>
											<template v-slot:actions>
												<div></div>
											</template>
										</GoalFolderItem>
									</div>
								</div>
								<div
									v-else
									class="w-full h-full flex items-center justify-center flex-col"
								>
									<img
										src="@/assets/images/illustrations/not_found.png"
										alt=""
										height="250"
										width="250"
									/>
									<div
										class="text-neutral-400 text-lg text-center"
										style="max-width: 900px"
									>
										Chưa có thư mục hay mục tiêu nào trong
										thư viện này.
										<br /><br />
										Nếu ngân hàng của bạn gồm nhiều mục tiêu
										được chia theo lĩnh vực hoặc chia theo
										độ tuổi hoặc theo vấn đề của trẻ thì bạn
										nên tạo Thư mục trước khi tạo Mục tiêu.
									</div>
								</div>
							</div>
							<div v-else class="fixed top-1/2 left-1/2">
								<Loading />
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import DaIcon from '@/components/elements/daIcon/DaIcon';
import GoalFolderItem from '@/views/goalFolders/features/GoalFolderItem';
import Loading from '@/components/common/Loading';
import { $api } from '@/services';
import CreateGoalModal from '@/views/createGoalByLib/CreateGoalModal';
import { useTutorial } from '@/features/tutorial/useTutorial';
import { isTutorialVirtualStudent } from '@/features/tutorial/virtualStudent';

export default {
	name: 'CreateGoalByLibGoals',
	components: {
		CreateGoalModal,
		Loading,
		GoalFolderItem,
		DaIcon,
	},
	data() {
		return {
			isLoading: true,
			goal: {
				id: '',
				name: '',
				created_by_staff: {
					name: '',
				},
				last_updated_at: null,
			},
			inProgress: false,
			skills: [],
			isDataLoading: true,
			modalIsOpen: false,
			goalPayloadData: null,
			error: '',
			tabActive: 0,
			folders: [],
			selected: [],
			alertShow: true,
		};
	},

	created() {
		this.$store.dispatch('clearSelected');
		this.fetchGoalLib();
		this.fetchSkill();
		this.fetchGoalFolders();
	},

	watch: {
		goalId() {
			this.isDataLoading = true;
			this.fetchGoalLib();
			this.fetchGoalFolders();
		},
	},

	computed: {
		goalId() {
			return this.$route?.params?.goalId || '';
		},

		isAdmin() {
			return this.$store.getters.isAdmin;
		},

		studentId() {
			return this.$route?.params?.id || '';
		},

		isAddGoalTour() {
			return useTutorial().isAddGoalTour.value;
		},

		goalsSelected() {
			const selected = this.$store.getters.goalsSelected;
			return (selected || []).map((i) => i.id);
		},
	},

	methods: {
		updated() {
			this.selected.push(this.goalPayloadData?.id);
			this.$emit('updated');
			this.closeModal();
		},

		async fetchSkill() {
			try {
				const {
					data: { data },
				} = await $api.goal.allSkills(this.isAdmin);
				if (data) {
					this.skills = data;
				}
			} catch (e) {
				console.log(e);
			}
		},

		async fetchGoalFolders() {
			try {
				const params = isTutorialVirtualStudent(this.studentId)
					? {}
					: { student_id: this.studentId };
				const {
					data: { data },
				} = await $api.goal.fetchAllGoalFolders(
					this.goalId,
					params,
					this.isAdmin
				);
				const folders = data || [];
				this.openAllFolders(folders);
				this.folders = folders;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			} finally {
				this.isDataLoading = false;
				this.$nextTick(() => {
					const el = document.querySelector(
						'[data-tour-id="bank-add-mt"]'
					);
					el?.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
						inline: 'nearest',
					});
				});
			}
		},

		openAllFolders(items) {
			(items || []).forEach((item) => {
				item.open = true;
				if (item.children?.length) {
					this.openAllFolders(item.children);
				}
			});
		},

		async fetchGoalLib() {
			try {
				const {
					data: { data },
				} = await $api.goal.fetchGoalLibDetail(
					this.goalId,
					this.isAdmin
				);
				this.goal = data;
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message:
						e?.response?.data?.errors?.join('<br/>') ||
						'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		async doGoal(goal) {
			const tutorial = useTutorial();
			if (
				isTutorialVirtualStudent(this.studentId) ||
				tutorial.isAddGoalTour.value
			) {
				await this.$store.dispatch('taughtGoal', goal.id);
				this.selected.push(goal.id);
				this.$emit('updated');
				if (tutorial.activeSpotlight.value?.targetId === 'bank-add-mt') {
					tutorial.setSpotlightByTarget('bank-tab-new');
				}
				return;
			}
			this.modalIsOpen = true;
			this.goalPayloadData = {
				...goal,
				library_item_id: goal?.id,
				id: goal?.goal_id,
				name: goal?.name || goal?.goal_name,
			};
		},

		async addMultiGoal() {
			if (this.goalsSelected.length == 0 && !this.isAddGoalTour) {
				return;
			}
			try {
				if (!isTutorialVirtualStudent(this.studentId)) {
					await $api.goal.addMultiGoal(this.studentId, {
						library_item_ids: this.goalsSelected,
					});
				}
				await this.$store.dispatch('setAlertMessage', {
					message: 'Đã thêm mục tiêu thành công',
				});
				for (let i of this.goalsSelected) {
					await this.$store.dispatch('taughtGoal', i);
				}
				this.$emit('updated');
				const tutorial = useTutorial();
				if (
					tutorial.isAddGoalTour.value &&
					(tutorial.activeSpotlight.value?.targetId ===
						'bank-add-selected' ||
						tutorial.activeSpotlight.value?.targetId ===
							'bank-add-mt')
				) {
					tutorial.setSpotlightByTarget('bank-tab-new');
				}
			} catch (e) {
				this.$store.dispatch('setAlertMessage', {
					message: 'Đã có lỗi xảy ra. Vui lòng thử lại',
					type: 'danger',
				});
			}
		},

		closeModal() {
			this.modalIsOpen = false;
			this.goalPayloadData = null;
			this.error = '';
			this.tabActive = 0;
		},
	},
};
</script>

<style scoped>
.delete-button {
	padding: 12px 20px;
	gap: 6px;
	border-radius: 4px;
	border: 1px solid #d89210;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	color: #d89210;
}
.disable-button {
	background: #e1e7ef !important;
	border: 1px solid #cbd5e1 !important;
	color: #cbd5e1;
}
</style>

